import * as z from "zod";
export const TestCaseResult = z.object({
    type: z.literal("test_case_result"),
    value: z.object({
        input: z.string(),
        output: z.string(),
        expected: z.string(),
    }),
});
